type Item = { kind: string; key: string };
type InputItem<I> = { kind: "input"; key: string; input: I };

export type CheckboxGroupItem<I> = { kind: "checkbox-group"; key: string; items: InputItem<I>[] };

/**
 * Folds back-to-back checkbox inputs into one group. Every checkbox on a page is drawn in a
 * checkbox card, so a lone checkbox (e.g. "I agree", or the only option left visible) gets the
 * same card as a multi-select question.
 */
export function groupCheckboxRuns<I extends { input_key: string }, T extends Item>(
    items: T[]
): (T | CheckboxGroupItem<I>)[] {
    const out: (T | CheckboxGroupItem<I>)[] = [];
    let run: InputItem<I>[] = [];

    const flush = () => {
        if (run.length > 0) out.push({ kind: "checkbox-group", key: `checkbox-group-${run[0]?.key}`, items: run });
        else out.push(...(run as unknown as T[]));
        run = [];
    };

    for (const item of items) {
        const input = item as unknown as InputItem<I>;
        if (item.kind === "input" && input.input?.input_key === "checkbox") {
            run.push(input);
            continue;
        }
        flush();
        out.push(item);
    }
    flush();
    return out;
}
